export const AcousticGuitarSlugs = [
    'acoustic-guitars',
    'martin-flattops',
    'gibson-and-epiphone-flattops',
    'taylor-flat-tops',
    'miscellaneous-flattops',
    'archtop-acoustic-guitars',
    'classical-guitars',
    'resonator-guitars',
];

export const ElectricGuitarSlugs = [
    'electric-guitars',
    'fender-electrics',
    'gibson-solidbody-electrics',
    'epiphone-electrics',
    'gretsch-electrics',
    'miscellaneous-solidbody-electrics',
    'hollowbody-electrics',
    'electric-steel-guitars',
];

export const BanjoSlugs = [
    'banjos',
    'tenor-plectrum-and-other-banjo-family',
    'five-string-banjos',
];



// WEBPACK FOOTER //
// ./src/constants/inventory_filter_slugs.ts